<script>
    import R, {LOADER} from "../lib/requests";
    import {PASSPORT_STATUS} from "../lib/constants";
    import passportsStore from "../stores/passportsStore";
    import Notifier from "../stores/notifier";
    import Modal from '../components/modal/Modal.svelte';
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PassportApiCheck from "./PassportApiCheck.svelte";
    import PassportInput from "../components/controls/PassportInput.svelte";
    import Alert from "../stores/alerts";
    import {copyObject} from "../lib/lib";

    export let closeCallback;

    let passports = {
        order_id: 0,
        member_id: 0,
        member: null,
        total: 0,
        passport_from: '',
        passport_to: '',
        status: PASSPORT_STATUS.DESTROY,
    };
    let passportFrom = '';
    let passportTo = '';
    let checkPassports = false;
    let checkResult = null;
    let failed = [];

    const onPassportChange = () => {
        console.log("passportFromChange");
        let from = parseInt(passportFrom) || 0;
        let to = parseInt(passportTo) || 0;
        passports.total = 0;
        checkPassports = false;
        checkResult = null;

        if (from == 0) {
            return;
        }

        if (from > 0 && to > 0) {
            if (from > to) {
                Alert.warning("Διαβατήρια", "Η σειρά των διαβατηρίων δεν είναι σωστή!");
                return;
            }
            passports.total = to - from + 1;
        } else {
            passports.total = 1;
        }

        passports.passport_from = passportFrom;
        passports.passport_to = passports.total == 1 ? passportFrom : passportTo;
    }

    const onDestroy = () => {
        Alert.confirm("Καταστροφή διαβατηρίων", `Να γίνει καταστροφή ${passports.total} διαβατηρίων;`,
            destroyPassports);
    }

    const destroyPassports = () => {
        // save passports to destroy

        const onSuccess = result => {
            $passportsStore.changed = true;
            Notifier.showMessage("Τα διαβατήρια καταχωρήθηκαν");
            passports.id = result.id;

            // destroy passports
            let data = copyObject(passports);
            data.status = PASSPORT_STATUS.DESTROY;
            passportsStore.setRequest(data, statusComplete);
        }

        const onFailure = err => {
            if (err.message) {
                Notifier.showError(err.message);
            }
        };

        R.handle(R.passport.create, passports, onSuccess, onFailure, LOADER.POPUP);
    }

    const statusComplete = param => {
        console.log("statusComplete", param);
        if (param.error) {
            passports.error = param.error;
        } else {
            passports = param;
            $passportsStore.changed = true;
            if (!passports.fail) {
                close(passports);
            }
        }
    }

    const checkComplete = (param) => {
        console.log("checkComplete", param);

        if (param) {
            checkResult = param;
            if (checkResult.fail && checkResult.fail.length > 0) {
                failed = checkResult.fail;
            }
        }
    }

    const close = (param) => {
        passports = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }
</script>

{#if passports}
    <Modal title="Διαβατήρια" modalSm on:close="{ close }">
        <div slot="body">
            <div class="row mb-3">
                <div class="col-6 mb-2">
                    <label>Διαβατήρια από</label>
                    <PassportInput bind:value={passportFrom} on:change={onPassportChange}/>
                </div>
                <div class="col-6 mb-2">
                    <label>Έως</label>
                    <PassportInput bind:value={passportTo} on:change={onPassportChange} disabled={!passportFrom}/>
                </div>
            </div>
            {#if passports?.total > 0}
                <div class="mb-3">Σύνολο: <b>{ passports.total }</b></div>
            {/if}

            {#if checkResult}
                {#if failed.length}
                    <div class="alert alert-danger p-2 mb-1">
                        Βρέθηκε σφάλμα σε κάποιους από τους αριθμούς διαβατηρίων!
                    </div>
                    <table class="table table-list table-sm mb-4">
                        <tbody>
                        {#each failed as item}
                            <tr>
                                <td class="ps-0">{ item.passport }</td>
                                <td class="pe-0">{ item.statusmessage }</td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="alert alert-info p-2 mb-1">
                        Ο έλεγχος ολοκληρώθηκε!
                    </div>
                {/if}
            {/if}

            {#if passports.error}
                <div class="mb-2">
                    Σφάλμα: <span class="text-danger">{ passports.error }</span>
                </div>
            {/if}

            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                {#if !checkResult}
                    <button class="btn btn-primary px-4" on:click="{ () => checkPassports = true }"
                            disabled={passports.total < 1}>
                        ΕΛΕΓΧΟΣ ΔΙΑΒΑΤΗΡΙΩΝ
                    </button>
                {:else}
                    <button class="btn btn-danger px-4" on:click={ onDestroy }>
                        ΚΑΤΑΣΤΡΟΦΗ
                    </button>
                {/if}
            </div>
        </div>
    </Modal>
{/if}

{#if checkPassports}
    <PassportApiCheck {passports} completeCallback="{ checkComplete }"/>
{/if}